import React, { Component } from 'react';

class CasesGrid extends Component {
  render() {
    const { data } = this.props;
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <section className="p-80px-tb">
        <div className="container">
          <div className="row">
            <div className="col-sm-8 offset-sm-2">
              <div className="section-title text-center m-50px-b">
                <h2>{data.pageTitle}</h2>
                {data.pageSubtitle && <p className="lead text-muted">{data.pageSubtitle}</p>}
              </div>
            </div>
          </div>

          {/* Case Studies Grid */}
          <div className="row">
            {data.studies && data.studies.map((caseItem, i) => {
              return (
                <div key={i} className="col-lg-6 m-30px-b">
                  <div className="service-box p-40px lg-p-30px h-100 bg-light">
                    <div className="case-header m-20px-b">
                      <h4 className="font-weight-bold text-primary">{caseItem.title}</h4>
                    </div>

                    <div className="case-challenge m-20px-b">
                      <h5 className="font-weight-bold">課題</h5>
                      <p className="text-muted">{caseItem.challenge}</p>
                    </div>

                    <div className="case-solution m-20px-b">
                      <h5 className="font-weight-bold">解決策</h5>
                      <p className="text-muted">{caseItem.solution}</p>
                    </div>

                    <div className="case-results">
                      <h5 className="font-weight-bold">成果</h5>
                      <p className="text-muted">{caseItem.result}</p>
                    </div>

                    {caseItem.url && (
                      <div className="case-link m-20px-t">
                        <a href={caseItem.url} className="btn btn-primary btn-sm">詳細を見る</a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default CasesGrid;